import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InitialVendorPageLoad'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InitialVendorPageLoadStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InitialVendorPageLoadStore",
			variables: false,
		})
	}
}

export async function load_InitialVendorPageLoad(params) {
  await initClient()

	const store = new InitialVendorPageLoadStore()

	await store.fetch(params)

	return {
		InitialVendorPageLoad: store,
	}
}
